import { useSelector } from "react-redux"
import { RootState } from "~Shared/store/rootState.interface"

export const useCurrentCurrencyExchange = () => useSelector(({ currency }: RootState) => currency.item)
